import { Dispatch, SetStateAction } from 'react'
import moment from 'moment'

// local imports
import DateUtil from 'utils/DateUtil'
import { IGetCoiffeurTimeTableList } from 'types/CoiffeurType'
import { DayHeader, GridContainer, GridItem, GridWrapper, HeaderWrapper, TimeButton } from './styled'

interface SchedulerProps {
  filterDate: Date
  setFilterDate: Dispatch<SetStateAction<Date>>
  tableWeek: { start: Date; end: Date }
  dailyReservations: any
  setSelectedReservation: Dispatch<SetStateAction<IGetCoiffeurTimeTableList | undefined>>
  selectedReservation: IGetCoiffeurTimeTableList | undefined
}

export default function ReservationScheduler({
  filterDate,
  setFilterDate,
  dailyReservations,
  setSelectedReservation,
  selectedReservation,
  tableWeek,
}: SchedulerProps) {
  // variables
  const hours = [...Object.values(dailyReservations)]
  const selectedDayByFilter = moment(filterDate).format('Do MMMM dddd')
  const weekDays = DateUtil.getWeekDayRange(tableWeek.start, tableWeek.end)
  const selectedTime = moment(selectedReservation?.reservationStartHour).format('Do MMMM dddd')
  const selectedDay = weekDays.find((wd) => wd === selectedTime)
  const isTimeSelected = (h: IGetCoiffeurTimeTableList) =>
    `${selectedReservation?.reservationStartHour}-${selectedReservation?.reservationEndHour}` ===
    `${h.reservationStartHour}-${h.reservationEndHour}`
      ? 'selected'
      : ''

  const isDaySelected = (day: string) => {
    if (!selectedReservation) return day === selectedDayByFilter
    else return day === selectedDay
  }

  const handleClick = (data: IGetCoiffeurTimeTableList) => {
    setSelectedReservation(data)
    const date = new Date(data.reservationStartHour)
    setFilterDate(date)
  }

  return (
    <>
      <HeaderWrapper>
        {weekDays.map((day) => (
          <DayHeader key={day} selected={isDaySelected(day)}>
            <span>{day}</span>
          </DayHeader>
        ))}
      </HeaderWrapper>

      <GridWrapper>
        <GridContainer>
          {hours?.map((hour: any, index) => (
            <GridItem key={index}>
              {hour?.map((h: IGetCoiffeurTimeTableList) => (
                <TimeButton
                  disabled={!h.isSelectable}
                  id={`${h.reservationStartHour}-${h.reservationEndHour}`}
                  onClick={() => handleClick(h)}
                  className={isTimeSelected(h)}
                  key={`${h.reservationStartHour}-${h.reservationEndHour}`}>
                  <span>
                    {h.reservationStartHourStr} - {h.reservationEndHourStr}
                  </span>
                </TimeButton>
              ))}
            </GridItem>
          ))}
        </GridContainer>
      </GridWrapper>
    </>
  )
}
